import { TranslationsContext } from '@telia-common-components/shared';
import React from 'react';
import { Card, CardContent, EqualHeight, Heading, Text } from 'telia-front-react';
import { renderOrderServiceCtaButton, renderPacketInfoRow, renderPrices, renderViewerSlots } from '../util/TvPackageOfferingCardUtil';
import { normalizeName } from '../../util/TvServicesUtil';
export const TvPackageOfferingModalCard = (props) => {
    const { tagTop, title, headingLevel = 3, channelCount, viewerCount, hasRecordedContent, prices, isExistingOffering, serviceOrderUrl, teliaWebSelfServiceUrl } = props;
    const { translate, translateOrEmpty } = React.useContext(TranslationsContext);
    const renderChannelCount = () => {
        return translate('tvPackageOfferings.channelsCount', { count: channelCount });
    };
    return (React.createElement(Card, null,
        React.createElement(CardContent, { background: 'neutral-bg-level-1', tagTop: !!tagTop ? tagTop : true },
            React.createElement(Text, null,
                React.createElement(Heading, { level: headingLevel, className: "h3" }, `${translate(`tvPackageOfferings.packageName.${normalizeName(title)}`)}`),
                React.createElement(EqualHeight, { group: "packet-info" },
                    renderPacketInfoRow('service-tv-check', renderChannelCount()),
                    renderPacketInfoRow('tv-viewslot', renderViewerSlots(viewerCount, title, translate, true)),
                    hasRecordedContent && renderPacketInfoRow('follow-up', translate('tvPackageOfferings.recordedContent'))),
                React.createElement("div", null, renderPrices(prices, translate, translateOrEmpty, true)),
                renderOrderServiceCtaButton(title, serviceOrderUrl, teliaWebSelfServiceUrl, isExistingOffering, translate)))));
};
